import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function TraceabilitySupplierViewModel(logout) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [supplierReceivingGrouped, setSupplierReceivingGrouped] =
    useState(null);
  const [supplierTraceResult, setSupplierTraceResult] = useState(null);
  const [supplierLotNumber, setSupplierLotNumber] = useState("");
  const [supplierIngredientId, setSupplierIngredientId] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const onTraceSupplierByLot = async function (lotNumber) {
    const trimmed = (lotNumber || "").trim();
    if (!trimmed) return;
    setLoading(true);
    setSupplierReceivingGrouped(null);
    setSupplierTraceResult(null);
    setSupplierIngredientId(null);
    const callResult = await makePostApiCall(`traceSupplierReceivingByLot`, {
      lot_number: trimmed,
    });
    if (callResult.success) {
      setSupplierReceivingGrouped(callResult.data);
      setSupplierLotNumber(trimmed);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data?.message || "No trace found.");
    }
    setLoading(false);
  };

  const onTraceSupplierByIngredient = async function (lotNumber, ingredientId) {
    const trimmed = (lotNumber || "").trim();
    if (!trimmed || ingredientId == null) return;
    setLoading(true);
    setSupplierIngredientId(ingredientId);
    const callResult = await makePostApiCall(
      `traceSupplierReceivingByLotAndIngredient`,
      { lot_number: trimmed, ingredient_id: ingredientId },
    );
    if (callResult.success) {
      setSupplierTraceResult(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data?.message || "No trace found.");
    }
    setLoading(false);
  };

  const onPrintTraceSupplierReceivingByLotAndIngredientReport =
    async function () {
      const resolvedLotNumber = (supplierLotNumber || "").trim();
      if (!resolvedLotNumber || supplierIngredientId == null) return;

      setReportLoading(true);
      const callResult = await makePostApiCall(
        `/qaReports/traceSupplierReceivingByLotAndIngredientReport`,
        {
          lot_number: resolvedLotNumber,
          ingredient_id: supplierIngredientId,
        },
      );

      if (callResult.success) {
        window.open(callResult.data.location, "_blank");
      } else {
        if (callResult.errorStatus === 401) {
          logout();
        }
        showErrorModal(
          "Report error",
          callResult.data?.message || "Failed to generate report.",
        );
      }

      setReportLoading(false);
    };

  const clearSupplierTrace = function () {
    setSupplierReceivingGrouped(null);
    setSupplierTraceResult(null);
    setSupplierLotNumber("");
    setSupplierIngredientId(null);
  };

  return {
    loading,
    supplierReceivingGrouped,
    supplierTraceResult,
    supplierLotNumber,
    supplierIngredientId,
    reportLoading,
    clearSupplierTrace,
    slideOver,
    setSlideOver,
    onTraceSupplierByLot,
    onTraceSupplierByIngredient,
    onPrintTraceSupplierReceivingByLotAndIngredientReport,
    emptyModal,
    setEmptyModelOpen,
  };
}
